var _defs, _polygon, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3StepPageHexagon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 73.4 82.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2d2d48;\n      }\n\n      .cls-2 {\n        fill: url(#New_Gradient_Swatch_2);\n      }\n\n      .cls-3 {\n        fill: #fff;\n        filter: url(#drop-shadow-41);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    "data-name": "New Gradient Swatch 2",
    x1: 22.4,
    y1: 63.9,
    x2: 65.7,
    y2: 15,
    gradientTransform: "translate(-6.5 .8) rotate(.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3904b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa437f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-41",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.3 60 4.3 22.5 36.7 3.8 69.1 22.5 69.1 60 36.7 78.7 4.3 60"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 36.9,
    cy: 40.8,
    r: 23.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.7,47.8c2.1-1.8,3.8-3.2,5-4.4s2.3-2.4,3.1-3.7c.8-1.3,1.3-2.5,1.3-3.8s-.3-2-.8-2.6c-.5-.6-1.3-1-2.4-1s-1.9,.4-2.5,1.1c-.6,.7-.9,1.7-.9,3h-4.5c0-2.6,.9-4.6,2.4-6,1.5-1.4,3.4-2,5.7-2s4.4,.7,5.8,2c1.3,1.3,2,3.1,2,5.3s-.5,3.4-1.4,4.9c-.9,1.6-2,2.9-3.2,4.1-1.2,1.2-2.7,2.5-4.7,4.2h9.7v3.8H29v-3.4l1.7-1.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3StepPageHexagon2);
export default __webpack_public_path__ + "static/media/3step-page-hexagon_2.5de1c37c66faf693251682a121262402.svg";
export { ForwardRef as ReactComponent };